import { currentLoggedUserVar } from '@/shared/api';
import { CANARY } from '@/shared/lib/constants/rolloutGroup';
import { SERVED_ROLLOUT_GROUP } from '@/shared/lib/util/rolloutGroupCookie';
import { gql, useQuery, useReactiveVar } from '@apollo/client';
import type { PaperProps } from '@mui/material';
import { alpha, Chip, Paper, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import pkg from '../../../../package.json';
import PharmacyFooterBadge from './PharmacyFooterBadge';
import { Small } from './Typography';
export const GET_VERSION = gql`
  query version {
    version {
      version
    }
  }
`;

export const VERSION_FOOTER_HEIGHT = 40;
export const VERSION_FOOTER_Z_INDEX = 9;

type Props = PaperProps & {
  contentOffset?: number;
  badgeOffset?: number;
};
const VersionFooter = ({ contentOffset = 0, badgeOffset, sx, ...props }: Props) => {
  const { loading: versionLoading, data: versionData, called: versionCalled } = useQuery(GET_VERSION);
  const [backendVersion, setBackendVersion] = useState('');
  const currentUser = useReactiveVar(currentLoggedUserVar);

  useEffect(() => {
    if (versionCalled && !versionLoading && versionData) {
      setBackendVersion(versionData.version.version);
    }
  }, [versionLoading, versionData, versionCalled]);

  return (
    <Paper
      component="footer"
      square
      variant="outlined"
      {...props}
      sx={[
        theme => ({
          backgroundColor: alpha(theme.palette.background.paper, 0.35),
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)'
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          height: '100%',
          py: 0.5,
          paddingLeft: `${contentOffset}px`
        }}
      >
        {/* Which pharmacy this is, on every page -- for people who switch between several. */}
        <PharmacyFooterBadge
          sx={{
            position: 'absolute',
            left: (badgeOffset ?? contentOffset) + 12,
            top: '50%',
            transform: 'translateY(-50%)',
            maxWidth: '30%'
          }}
        />

        <Small
          sx={{
            fontSize: 12
          }}
        >
          We ♥️ Pharmacies!
        </Small>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: 'center',
            position: 'absolute',
            right: 12,
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        >
          {SERVED_ROLLOUT_GROUP === CANARY && <Chip label="Canary build" size="small" color="info" sx={{ height: 16, fontSize: 9 }} />}
          <Small
            sx={{
              fontSize: 10
            }}
          >
            Pv: {pkg.version}
            {currentUser && ` · Bv: ${backendVersion}`}
          </Small>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default VersionFooter;
